import { useSelector } from 'react-redux';
import { getLengthLabel } from '../Components/helper';

interface SystemMastersState {
  SystemMastersDetails?: {
    variableOneName?: string;
  };
}

/**
 * BM-9583: Resolve the company-configurable display name for the "Length" attribute (Variable 1).
 * Prefers the live Redux value (so an Admin rename reflects without a reload), falling back to the
 * persisted logged-in user info and finally to the supplied label (typically the i18n "Length" string).
 * @param fallback - Text to use when no custom name exists (e.g. t('...LENGTH')).
 * @returns The custom Length attribute name, or the fallback.
 */
export const useLengthLabel = (fallback = 'Length'): string => {
  const variableOneName = useSelector((state: SystemMastersState) => state.SystemMastersDetails?.variableOneName);
  if (typeof variableOneName === 'string' && variableOneName.trim()) {
    return variableOneName;
  }
  return getLengthLabel(fallback);
};
